import { FlowNodeTypes } from '../types'

// V2.9 is a real node type: it saves and loads as `ai_agent_v29`, and
// agent-runner switches on that type. Everything else — sidebar, defaults,
// output states, schema, nodevars, channels — is shared with ai_agent_v2.
export const AI_AGENT_V29_LABEL = 'AI conversation v2.9'

// The two builder types are the same node everywhere except the palette entry
// and the Extract Variables panel.
export const isAiAgentV2Type = (type?: string | null): boolean =>
  type === FlowNodeTypes.ai_agent_v2 || type === FlowNodeTypes.ai_agent_v29
